import ACallingActionButton from './index.vue';

ACallingActionButton.install = app => {
  app.component(ACallingActionButton.name, ACallingActionButton);
};

export default ACallingActionButton;
